// extracted by mini-css-extract-plugin
module.exports = {"page":"_19076","image":"_19470"};